<template>
  <div class='gsdt_con'>
    <div class='block1 w_1200 text_center'>
      <h3>{{ $t('about.news.title') }}</h3>
      <div class='img_box'><img src='@/assets/img/Mask@2x(1).png' style='transform: rotate(2deg);' alt=''></div>
    </div>
    <div class='block2 w_1200'>
      <ul class='fz_0'>
        <li v-for='item in newsList' :key='item.id'>
          <div @click='toNewPage("/company-newsDetail/"+item.id)'>
            <div class='img_box'><img :src='item.cover_picture' alt=''></div>
            <div class='text'>{{ item.title }}</div>
            <div class='date'>{{ item.date }}</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { setTitle } from 'utils'
import { getAllNews } from '@/service'

export default {
  name: 'CompanyNewsList',
  components: { },
  data () {
    return {
      newsList: [],
      detailObj: {},
    }
  },
  beforeMount () {
    setTitle(`${this.$t('home.logo')} - ${this.$t('about.news.title')}`)
  },
  mounted () {
    this.getNews()
  },
  methods: {
    getNews () {
      getAllNews().then(res => {
        this.newsList = res.data.items
      })
    },
    toNewPage (link) {
      this.$router.push({ path: link })
    },
  },
}
</script>
